<template>
  <nav
    v-if="false && $root.isMobile"
    class="d-md-none fixed-bottom"
    style="max-height: 8vh; justify-content: space-around; display: flex; background-color: #fff; border-top: 1px solid #dee2e6"
  >
    <svg
      @click="onHome"
      style="color: #333333; width: 15%"
      viewBox="0 0 24 24"
    >
      <use :xlink:href="urls.getIconURL('home')" />
    </svg>
    <svg
      @click="onStar"
      style="color: #333333; width: 15%"
      viewBox="0 0 24 24"
    >
      <use :xlink:href="urls.getIconURL('search')" />
    </svg>
    <svg
      @click="onStar"
      style="color: #333333; width: 15%"
      viewBox="0 0 24 24"
    >
      <use :xlink:href="urls.getIconURL('star')" />
    </svg>
    <svg
      @click="onNew"
      style="color: #333333; width: 15%"
      viewBox="0 0 24 24"
    >
      <use :xlink:href="urls.getIconURL('new')" />
    </svg>
    <svg
      @click="onPerson"
      style="color: #333333; width: 15%"
      viewBox="0 0 24 24"
    >
      <use :xlink:href="urls.getIconURL('person')" />
    </svg>
  </nav>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component';
import RootVue from "@/RootVue.vue";
import SearchForm from "@/component/parts/SearchForm.vue";
import urls from "@/URLs";

@Options({
  components: {
    SearchForm,
  },
})
export default class extends Vue {
  // @ts-expect-error
  $root: RootVue;
  readonly urls = urls;


  onHome() {
    console.log("onHome!");
  }

  onStar() {
    console.log("onStar!");
  }

  onNew() {
    console.log("onNew!");
  }

  onPerson() {
    console.log("onPerson!");
  }

}
</script>

<style lang="scss" scoped>

@media (min-width: 992px){
    .fixed-bottom {
        display: none;
    }
}

.fixed-bottom {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1030;
}

</style>
